import React, { useContext } from 'react'
import ReactDOM from 'react-dom'

import DataContext from '../../contexts/data.jsx'

import Property from './Property.jsx'

const PropertiesGroup = ({ propertyGroup, setData }) => {
    const data = useContext(DataContext),
    handleChange = (property, propertyGroup, e) => {
        const newContextData = Object.assign({}, data)

        const field = newContextData.contacts.fields[propertyGroup.ID][property.CODE],
        value = e.target.value

        field.value = value

        try {
            if (field.REQUIRED === false && value === '') {
                field.isErrors = false
            } else {
                const regExp = field.SETTINGS.PATTERN ? new RegExp(field.SETTINGS.PATTERN) : null
                
                if (regExp) {
                    field.isErrors = !regExp.test(value)
                }
            }
        } catch(e) {
            
        }
        
        setData(newContextData)
    }

    return <div className={ `happy-order__contacts-group happy-order__contacts-group_${ propertyGroup.ID }` }>
        { propertyGroup.PROPERTIES ? propertyGroup.PROPERTIES.map((property) => {
            return <Property
                key={ `contacts-property-${ property.ID }` }
                property={ property }
                field={ data.contacts.fields[propertyGroup.ID][property.CODE] }
                propertyGroup={ propertyGroup }
                handleChange={ handleChange }
                />
        }) : null }
    </div>
}

export default PropertiesGroup